import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./auth/authConfig";
import { MsalProvider } from "@azure/msal-react";
import { RumInit } from '@maersk-global/telemetry-web-sdk';
import {
  createRoutesFromChildren,
  matchRoutes,
  Routes,
  useLocation,
  useNavigationType
} from 'react-router-dom';
import { ReactIntegration, ReactRouterVersion } from '@grafana/faro-react';
import './wdyr'; // <--- first import
import { rumKey } from "./config";
import './Utils/macAutoAddOwners';

// import 'react-hot-loader';
// import {hot} from 'react-hot-loader/root';

if(process.env.REACT_APP_ENV === 'PROD'){
 const faro = RumInit({
    app: {
      name: "Postmortem",
      version: "1.0"
    },
    apiKey:rumKey, 
    debug: false, // false: Prevent showing log,error,etc captured in browser console
    traceLog: true, // Sends Traces to Loki ( For easy querying of traces)
    sso_user: true,
    batching: {
      sendTimeout: 5000, // flush RUM events every 5s instead of every 250ms
      itemLimit: 100,
    },
    instrumentations:{
      console: { disabledLevels: ['log', 'info', 'debug'] }, // keep only warn/error console output
      interactions: true,
      // or 
      // interactions: {
      //   eventNames: ['click','mousedown']
      // }
      xhr: false
    }
  });
  // const error = new Error('I am supposed to fail');
  // ...
  // And at some point you want to pipe it to Faro
  // faro.api.pushError(error);
  
  faro.instrumentations.add(
    new ReactIntegration({
    // If the version of React Router is V6
    router: {
      version: ReactRouterVersion.V6,
      dependencies: {
        createRoutesFromChildren,
        matchRoutes,
        Routes,
        useLocation,
        useNavigationType
      }
    }
    // For React Router V4/V5
  })
  )
}




// import "@maersk-global/fonts/maersk/fonts.css";
const msalInstance = new PublicClientApplication(msalConfig);

// const HotApp = hot(App);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <MsalProvider instance={msalInstance}>
    <App/>
    </MsalProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
